import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import React, { useRef } from 'react';
import { NewRadioButton } from '../../../NewRadioButton';
import { Select } from '../../../ui/Select';
import { capitalizeFirstLetter } from '../../../../utils/helpers/common';
import { TypeFilterContainer } from './styled';
import { BUILDING_TYPE_ID } from '../../../../utils/helpers/constants';
import { getTypeFilterOptions } from '../../../../utils/helpers/getTypeFilterOptions';
import { FilterFieldProps, SelectRefType } from '../types';
import useScreenSize from '../../../../hooks/useScreenSize';
import { NewSearchCategories } from '../../NewSearchCategories';

export const BuildingTypeFilter: React.FC<FilterFieldProps> = ({
  submitOnChange = false
}) => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change, submit } = useForm();
  const { isSmall } = useScreenSize();
  const selectRef = useRef<SelectRefType>(null);

  const selectedValue = capitalizeFirstLetter(
    t(`pages.current_item.categories.id_${values.category_id}`)
  );
  const typePlaceholder = t('pages.current_item.building_type');

  const handleChangeOption = (itemId: string) => {
    change('category_id', itemId);
    if (selectRef.current) {
      selectRef.current.closePopover();
    }
    if (submitOnChange) {
      submit();
    }
  };

  return (
    <Select
      ref={selectRef}
      placeholder={typePlaceholder}
      value={selectedValue}
      cypress="new-search-type-filter"
      width={195}
      modalTitle={t('new_search.type_estate')}
      modalCypress="filter-modal"
    >
      <TypeFilterContainer>
        {!isSmall ? (
          getTypeFilterOptions(BUILDING_TYPE_ID).map(type => (
            <NewRadioButton
              key={type.data.id}
              data={{
                ...type.data,
                name: capitalizeFirstLetter(t(type.data.name))
              }}
              currentValue={values.category_id}
              onChangeHandler={() => handleChangeOption(type.data.id)}
              name={type.name}
              cypress={type.name}
              stat={type.name}
            />
          ))
        ) : (
          <NewSearchCategories
            onClick={handleChangeOption}
            selectedValue={values.category_id}
          />
        )}
      </TypeFilterContainer>
    </Select>
  );
};
